import get from 'lodash/get';

export const Hours = data => ({
  id: data.id,
  name: data.name,
  hours: data.hours || {},
  timezone: data.timezone,
  timezoneOffset: data.timezoneOffset,
  default: data.default || false,
});

export const defaultHours = Hours({
  name: 'Default Hours',
  timezone: 'America/New_York',
  default: true,
  hours: {
    0: [[0, 1440]],
    1: [[0, 1440]],
    2: [[0, 1440]],
    3: [[0, 1440]],
    4: [[0, 1440]],
    5: [[0, 1440]],
    6: [[0, 1440]],
  },
});

export const responseDataToHours = responseData => {
  return new Hours({
    id: get(responseData, 'id'),
    name: get(responseData, 'attributes.name'),
    hours: get(responseData, 'attributes.hours'),
    timezone: get(responseData, 'attributes.timezone'),
    timezoneOffset: get(responseData, 'attributes.timezoneOffset'),
    default: get(responseData, 'attributes.default'),
  });
};

export const responseToHours = response => {
  if (!response) {
    return defaultHours;
  }
  return responseDataToHours(response.data.data);
};
